module.exports = __webpack_public_path__ + "img/home_four_007.6ccf9cb6.png";